export const EMPTY_CATEGORY_FILTER = 'no-category'
export const ALL_CATEGORIES_FILTER = 'all-categories'
